<template>
  <div class="Freight-Forwarding-Report-Main">
    <div class="left-container">
      <Menus :hideIcon="true">
        <div class="menu-container">
          <button @click="refreshClicked">Refresh</button>
          <Dropdown
            :items="itemReportName"
            itemKey="Report"
            :selectedObject.sync="selectedReportName"
            textAlign="left"
            placeholder="Report Name"
            :isRequired="true"
            :errorMessage.sync="errorReportName"
          />
          <Dropdown
            :items="itemDateField"
            itemKey="Date Field"
            placeholder="Date Field"
            textAlign="left"
            :isRequired="true"
            :selectedObject.sync="selectedDateField"
            :errorMessage.sync="errorDateField"
          />
          <DateTimePicker
            placeholder="From"
            :value.sync="selectedFromDate"
            :showTime="false"
            :isDisable="false"
            :isRequired="true"
            :errorMessage.sync="fromDateError"
          />
          <DateTimePicker
            placeholder="To"
            :value.sync="selectedToDate"
            :showTime="false"
            :isDisabled="false"
            :isRequired="true"
            :errorMessage.sync="toDateError"
          />
        </div>

        <div class="separator"></div>

        <div class="filter-container">
          <div class="filter-table1">
            <div class="separator"></div>
            <Filters
              class="customer-filter"
              title="Customer"
              :tableData="cusData"
              itemKey="Customer Code"
              itemDesc="Description"
              @confirmClicked="filterCus"
            />
            <Filters
              class="shprcsgn-filter"
              title="ShprCsgn"
              :tableData="shprcsgnData"
              itemKey="ShprCsgn Code"
              itemDesc="Description"
              @confirmClicked="filterShprCsgn"
            />
          </div>
        </div>

        <div class="tab-closed" slot="collapse">
          <img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-refresh-64.png" @click="refreshClicked" />
        </div>
      </Menus>
    </div>
    <div class="right-container">
      <div class="upper-section">
        <div class="left-side">
          <div class="filtered-content">
            <div class="filtered-title"> Report Name </div>
            <div class="filtered-colon"> : </div>
            <div class="filtered-result">
              {{ injectedReportName }}
            </div>
          </div>

          <div class="filtered-content">
            <div class="filtered-title"> Date Field </div>
            <div class="filtered-colon"> : </div>
            <div class="filtered-result">
              {{ injectedDateField }}
            </div>
          </div>

          <div class="filtered-content">
            <div class="filtered-title"> From </div>
            <div class="filtered-colon"> : </div>
            <div class="filtered-result">
              {{ injectedFromDate }}
            </div>
          </div>

          <div class="filtered-content">
            <div class="filtered-title"> To </div>
            <div class="filtered-colon"> : </div>
            <div class="filtered-result">
              {{ injectedToDate }}
            </div>
          </div>
        </div>

        <div class="left-side" style="flex-direction: column">
          <div class="filtered-content">
            <div class="filtered-title"> Customer </div>
            <div class="filtered-colon"> : </div>
            <div class="filtered-result">
              {{ tempcus == '' ? 'All' : tempcus }}
            </div>
          </div>
          <div class="filtered-content">
            <div class="filtered-title"> Shpr / Csgn </div>
            <div class="filtered-colon"> : </div>
            <div class="filtered-result">
              {{ tempshpr == '' ? 'All' : tempshpr }}
            </div>
          </div>
        </div>

        <div class="right-side" style="align-items: start"> Last Refreshed : {{ lastRefreshed }} </div>
      </div>
      <div class="lower-section">
        <TableBox
          style="padding: 5px"
          class="table-box"
          :title="injectedReportName"
          :tableData="tripData"
          :loading="tableLoading"
          :hideColumns="columnsHide"
          :maxSelection="0"
          :dataType="columnsNumber"
          :columnOrderViews.sync="tableBoxColumnOrderViews"
          :columnOrderID="tableBoxColumnOrderID"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {},
  data: function () {
    return {
      closeLeftTab: false,

      // data for loader
      loading: false,
      loadingText: '',
      lastRefreshed: null,

      cusData: [],
      shprcsgnData: [],
      selectedCus: [],
      selectedShprCsgn: [],
      tempshpr: '',
      tempcus: '',
      // data for dropdown
      itemReportName: [],
      selectedReportName: null,
      injectedReportName: '',
      errorReportName: '',
      itemDateField: [],
      selectedDateField: null,
      injectedDateField: '',
      errorDateField: '',

      // data for datetimepicker components
      selectedFromDate: null,
      injectedFromDate: '',
      fromDateError: '',
      selectedToDate: null,
      injectedToDate: '',
      toDateError: '',

      //data for tablebox
      tripData: [],
      tableLoading: false,
      columnsHide: [],
      columnsNumber: {},

      tableBoxColumnOrderViews: [],
      columnOrderViewsByReportName: {},
      tableBoxColumnOrderID: null,
    };
  },
  props: {},
  methods: {
    refreshClicked: async function () {
      this.tripData = [];
      this.tableBoxColumnOrderViews = [];
      this.tableBoxColumnOrderID = null;

      this.filterCheck();

      this.injectedReportName = this.selectedReportName['Report'];
      this.injectedDateField = this.selectedDateField['Date Field'];

      this.injectedFromDate = this.selectedFromDate.formatString('yyyy-MM-dd');
      this.injectedToDate = this.selectedToDate.formatString('yyyy-MM-dd');

      this.tempshpr =
        this.selectedShprCsgn.length == 0 ?
          ''
        : this.selectedShprCsgn
            .map((shiper) => {
              return shiper['ShprCsgn Code'].trim();
            })
            .join(',');
      this.tempcus =
        this.selectedCus.length == 0 ?
          ''
        : this.selectedCus
            .map((cus) => {
              return cus['Customer Code'].trim();
            })
            .join(',');

      let dataToPost = {
        datetype: this.selectedDateField['Date Field'].trim(),
        startdate: this.selectedFromDate.formatString('yyyy-MM-dd'),
        enddate: this.selectedToDate.formatString('yyyy-MM-dd'),
        reportname: this.selectedReportName['Report'].trim(),
        customerarray: this.tempcus,
        shprcsgnarray: this.tempshpr,
      };
      //console.log(dataToPost);

      this.tableLoading = true;

      let data = await this.$apiCallV2(`/FreightForwardingReport/GetFreightForwardingReport`, dataToPost);
      //console.log(data);
      if (data.length > 0) {
        data = this.$jsonNullToStringV2(data);
        data = this.$deepTrimJsonV3(data);

        let numericalColumns = Object.keys(data[0]).filter((i) => {
          return i.includes('Total') || i.includes('KGM') || i.includes('M3');
        });

        let numObj = {};
        numericalColumns.forEach((i) => {
          numObj[i] = 'number';
        });
        this.columnsNumber = numObj;

        // console.log(data);

        const columnOrderID = {
          formname: 'FMS_FreightForwardingReport',
          formctrlname: this.injectedReportName,
        };
        if (!this.columnOrderViewsByReportName[this.injectedReportName]) {
          this.columnOrderViewsByReportName[this.injectedReportName] = await this.$apiCallV2(
            '/TableBox/GetColumnOrder',
            columnOrderID,
          );
        }
        this.tripData = data;
        this.tableBoxColumnOrderViews = this.columnOrderViewsByReportName[this.injectedReportName];
        this.tableBoxColumnOrderID = columnOrderID;
      }
      this.tableLoading = false;
    },
    filterCheck: function () {
      if (!this.selectedReportName) {
        this.errorReportName = 'Please select a report name';
        return;
      }
      if (!this.selectedDateField) {
        this.errorDateField = 'Please select a date field';
        return;
      }
      if (!this.selectedFromDate) {
        this.fromDateError = 'Please select a date';
        return;
      }
      if (!this.selectedToDate) {
        this.toDateError = 'Please select a date';
        return;
      }
    },
    filterCus: function (items) {
      this.selectedCus = items;
    },
    filterShprCsgn: function (items) {
      this.selectedShprCsgn = items;
    },
  },
  async mounted() {
    let currentDate = new Date();
    this.lastRefreshed = currentDate.formatString('yyyy-MM-dd HH:mm:ss');

    // // default from Date and to Date to beginning of the month to end of the month
    this.selectedFromDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    this.selectedToDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    // retreive get list master data for dropdowns
    this.$fullscreenLoading('Getting Report Name');
    this.itemReportName = await this.$apiCallV2(
      `/FreightForwardingReport/GetListMaster?masterfile=RPT_REPORT&module=FMS`,
    );
    this.selectedReportName = this.itemReportName[0];
    //console.log(this.itemReportName[0]);
    this.$fullscreenLoading();

    this.loadText = 'Getting Customers';
    this.cusData = await this.$apiCallV2('/JobMilestones/GetListMaster?master=BILLCUSTNAME');

    this.loadText = 'Getting Shipper Consignee';
    this.shprcsgnData = await this.$apiCallV2('/JobMilestones/GetListMaster?master=SHPRCSGNNAME');

    this.$fullscreenLoading('Getting Date Field');
    this.itemDateField = await this.$apiCallV2(
      '/FreightForwardingReport/GetListMaster?masterfile=RPT_REPORT_DATEFIELD&module=FMS',
    );
    this.selectedDateField = this.itemDateField[0];
    //console.log(this.selectedDateField);
    this.$fullscreenLoading();
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.Freight-Forwarding-Report-Main {
  font-size: 12px;
  width: 200px;
  height: 100%;
  padding: 10px 45px;
  display: flex;
  overflow: hidden;

  > .left-container {
    margin-right: 5px;
    height: 100%;
    background-color: white;
    display: flex;
    flex-direction: column;

    > * > .filter-container {
      width: 100%;

      > .filter-table1 {
        height: calc(100%);
        min-height: 200px;
        display: flex;

        > .cus-filter > .shprcsgn-filter {
          height: 100%;
        }
      }
    }

    > * > .menu-container {
      > button {
        width: 100%;
      }
      margin-top: 50px;
      width: 100%;
      height: 200px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;
    }
    > * > .tab-closed {
      width: 28px;
      height: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 50px;

      > img {
        width: 26px;
        height: 26px;
        cursor: pointer;
      }
      &:hover {
        background-color: rgba(130, 127, 127, 0.5);
        transition: 0.3s;
        border-radius: 5px;
      }
    }
  }

  > .right-container {
    border-radius: 5px;
    width: 100%;
    height: 100%;
    overflow: hidden;

    > .upper-section {
      width: 100%;
      border-radius: 5px;
      height: 80px;
      background-color: white;
      margin-bottom: 5px;
      display: flex;
      justify-content: space-between;
      // align-items: center;
      align-items: start;

      > .left-side {
        padding-left: 5px;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-around;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        align-items: start;
        display: flow-root;

        > .filtered-content {
          display: flex;

          > .filtered-title {
            min-width: 185px;
            max-width: 185px;
          }

          > .filtered-colon {
            padding: 0 5px;
          }
        }
      }

      > .right-side {
        padding-right: 5px;
      }
    }

    > .lower-section {
      height: calc(100% - 83px);
      width: 100%;
      padding: 5px;
      border-radius: 5px;
      background-color: white;
    }
  }
}
</style>
